
import CommonAcf from '../common/CommonAcf.vue'

export default CommonAcf.extend({
  name: 'LogoBelt',
})
